/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./preview-dialog.vue?vue&type=template&id=6d60e310&scoped=true&"
import script from "./preview-dialog.vue?vue&type=script&lang=ts&"
export * from "./preview-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./preview-dialog.vue?vue&type=style&index=0&id=6d60e310&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d60e310",
  null
  
)

export default component.exports